import { ComponentProps } from 'react';
import { TextInput } from '@/components/form/TextInput.tsx';
import { applyPostalCodeMask } from '@/components/form/postalCodeMask.ts';

type PostalCodeInputProps = Omit<
  ComponentProps<typeof TextInput>,
  'type' | 'inputMode' | 'placeholder'
>;

/**
 * Pole polskiego kodu pocztowego: klawiatura numeryczna i maska `XX-XXX`.
 * Bez `maxLength` — obcinałby wklejony tekst, zanim maska wybierze z niego cyfry.
 */
const PostalCodeInput = ({ register, ...props }: PostalCodeInputProps) => (
  <TextInput
    {...props}
    inputMode="numeric"
    placeholder="00-000"
    register={{
      ...register,
      // Maska wchodzi do DOM przed `register.onChange`, bo to stamtąd
      // react-hook-form czyta wartość pola.
      onChange: (event) => {
        event.target.value = applyPostalCodeMask(event.target.value);
        return register.onChange(event);
      },
    }}
  />
);

export default PostalCodeInput;
